module.exports = __webpack_public_path__ + "static/Newspaper-ada55ccd6a194c599fc04ca42e88feef.jpg";